import { GlFormCheckbox } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'BoardConfigurationOptions',
    components: {
        GlFormCheckbox
    },
    props: {
        hideBacklogList: {
            type: Boolean,
            required: true
        },
        hideClosedList: {
            type: Boolean,
            required: true
        },
        readonly: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'update:hide-backlog-list',
        'update:hide-closed-list'
    ]
};
